import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import styles from './view-more.module.css';
import { TertiaryButton } from '../general/tertiary-button/tertiary-button';
import classNames from 'classnames';
import { ChevronIcon, useWindowResize } from '@keplerco/core';

function checkHasOverflow(paragraphElement: HTMLParagraphElement | null) {
  if (!paragraphElement) return false;
  const hasOverflow = paragraphElement.clientWidth < paragraphElement.scrollWidth || paragraphElement.clientHeight < paragraphElement.scrollHeight;
  return hasOverflow;
}

export default function ViewMore({ children }: PropsWithChildren) {
  const [width] = useWindowResize();

  const paragraphRef = useRef<HTMLParagraphElement>(null);

  const [hasOverflow, setHasOverflow] = useState<boolean>(false);
  const [showMore, setShowMore] = useState<boolean>(false);

  useEffect(() => {
    setHasOverflow(checkHasOverflow(paragraphRef.current));
  }, [width, children]);

  return (
    <div>
      <p ref={paragraphRef} className={classNames(styles.paragraph, { [styles.showMore]: showMore })}>
        {children}
      </p>

      {hasOverflow && (
        <TertiaryButton type="button" onClick={() => setShowMore(currentState => !currentState)}>
          View {!showMore ? 'more' : 'less'}
          <div className={classNames(styles.chevron, { [styles.showMore]: showMore })}>
            <ChevronIcon size={16} strokeWidth={2} tone="primary" rotation={2} />
          </div>
        </TertiaryButton>
      )}
    </div>
  );
}
